<template>
  <div class="coupon-page">
    <Card>
      <div class="toolbar">
        <Button type="primary" @click="openCreate">新建券模板</Button>
        <Button class="m-l-10" @click="openGrant">发放给用户</Button>
        <Button class="m-l-10" @click="load">刷新</Button>
      </div>
      <Table class="m-t-16" :loading="loading" :columns="columns" :data="list" border stripe />
    </Card>

    <Modal v-model="showForm" :title="form._id ? '编辑模板' : '新建模板'" @on-ok="saveForm" @on-cancel="resetForm">
      <Form :label-width="100">
        <FormItem label="名称">
          <Input v-model="form.name" placeholder="展示名称" />
        </FormItem>
        <FormItem label="类型">
          <Select v-model="form.biz_type" style="width: 200px">
            <Option value="mall">购物</Option>
            <Option value="car">用车</Option>
          </Select>
        </FormItem>
        <FormItem label="减免(分)">
          <InputNumber v-model="form.discount_fen" :min="1" style="width: 200px" />
          <span class="hint">100 分 = 1 元</span>
        </FormItem>
        <FormItem label="门槛(分)">
          <InputNumber v-model="form.threshold_fen" :min="0" style="width: 200px" />
        </FormItem>
        <FormItem label="有效天数">
          <InputNumber v-model="form.days_valid" :min="1" style="width: 200px" />
        </FormItem>
        <FormItem label="库存">
          <Input v-model.number="form.stock" placeholder="-1 表示不限" />
        </FormItem>
        <FormItem label="每人限领">
          <InputNumber v-model="form.per_user_limit" :min="1" style="width: 200px" />
        </FormItem>
        <FormItem label="首页可领">
          <i-switch v-model="form.popup_enabled" />
        </FormItem>
        <FormItem label="状态">
          <Select v-model="form.status" style="width: 200px">
            <Option value="on">上架</Option>
            <Option value="off">下架</Option>
          </Select>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="form.remark" type="textarea" :rows="2" />
        </FormItem>
      </Form>
    </Modal>

    <Modal v-model="showGrant" title="发放优惠券" @on-ok="doGrant">
      <Form :label-width="100">
        <FormItem label="客户 _id">
          <Input v-model="grant.customer_id" placeholder="customers 表 Mongo _id" />
        </FormItem>
        <FormItem label="或 openid">
          <Input v-model="grant.openid" placeholder="与上一项二选一" />
        </FormItem>
        <FormItem label="模板 _id">
          <Input v-model="grant.template_id" placeholder="下表中的 _id" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { couponTemplateList, couponTemplateCreate, couponTemplateUpdate, couponGrant } from '@/api/coupon'

export default {
  name: 'CouponManage',
  data() {
    return {
      loading: false,
      list: [],
      showForm: false,
      showGrant: false,
      form: this.emptyForm(),
      grant: { customer_id: '', openid: '', template_id: '' },
      columns: [
        { title: '名称', key: 'name', minWidth: 140 },
        {
          title: '类型',
          key: 'biz_type',
          width: 90,
          render: (h, { row }) => h('span', row.biz_type === 'mall' ? '购物' : '用车'),
        },
        { title: '减免(分)', key: 'discount_fen', width: 100 },
        { title: '门槛(分)', key: 'threshold_fen', width: 100 },
        { title: '有效天', key: 'days_valid', width: 80 },
        { title: '库存', key: 'stock', width: 80 },
        { title: '已发', key: 'issued', width: 80 },
        { title: '限领/人', key: 'per_user_limit', width: 90 },
        {
          title: '弹窗',
          key: 'popup_enabled',
          width: 70,
          render: (h, { row }) => h('span', row.popup_enabled ? '是' : '否'),
        },
        { title: '状态', key: 'status', width: 80 },
        {
          title: '操作',
          key: '_id',
          width: 120,
          render: (h, { row }) =>
            h(
              'Button',
              {
                props: { type: 'text', size: 'small' },
                on: { click: () => this.edit(row) },
              },
              '编辑'
            ),
        },
      ],
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    emptyForm() {
      return {
        _id: '',
        name: '',
        biz_type: 'mall',
        discount_fen: 100,
        threshold_fen: 0,
        days_valid: 30,
        stock: -1,
        per_user_limit: 1,
        popup_enabled: false,
        status: 'on',
        remark: '',
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await couponTemplateList()
        if (res.data.code === 200) {
          this.list = res.data.data || []
        } else {
          this.$Message.error(res.data.msg || '加载失败')
        }
      } catch (e) {
        this.$Message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.form = this.emptyForm()
      this.showForm = true
    },
    edit(row) {
      this.form = {
        _id: row._id,
        name: row.name,
        biz_type: row.biz_type,
        discount_fen: row.discount_fen,
        threshold_fen: row.threshold_fen,
        days_valid: row.days_valid,
        stock: row.stock,
        per_user_limit: row.per_user_limit,
        popup_enabled: !!row.popup_enabled,
        status: row.status || 'on',
        remark: row.remark || '',
      }
      this.showForm = true
    },
    resetForm() {
      this.form = this.emptyForm()
    },
    async saveForm() {
      try {
        if (!this.form.name) {
          this.$Message.warning('请填写名称')
          return
        }
        if (this.form._id) {
          const res = await couponTemplateUpdate(this.form._id, { ...this.form, _id: undefined })
          if (res.data.code === 200) {
            this.$Message.success('已保存')
            this.showForm = false
            this.load()
          } else this.$Message.error(res.data.msg)
        } else {
          const res = await couponTemplateCreate({ ...this.form, _id: undefined })
          if (res.data.code === 200) {
            this.$Message.success('已创建')
            this.showForm = false
            this.load()
          } else this.$Message.error(res.data.msg)
        }
      } catch (e) {
        this.$Message.error('保存失败')
      }
    },
    openGrant() {
      this.grant = { customer_id: '', openid: '', template_id: '' }
      this.showGrant = true
    },
    async doGrant() {
      try {
        if (!this.grant.template_id) {
          this.$Message.warning('请填写模板 _id')
          return
        }
        if (!this.grant.customer_id && !this.grant.openid) {
          this.$Message.warning('请填写客户 _id 或 openid')
          return
        }
        const res = await couponGrant({ ...this.grant })
        if (res.data.code === 200) {
          this.$Message.success('发放成功')
          this.showGrant = false
          this.load()
        } else this.$Message.error(res.data.msg)
      } catch (e) {
        this.$Message.error('发放失败')
      }
    },
  },
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
}
.m-l-10 {
  margin-left: 10px;
}
.m-t-16 {
  margin-top: 16px;
}
.hint {
  margin-left: 8px;
  color: #999;
  font-size: 12px;
}
</style>
